// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.letter-container {
  padding: 20px;
  background: white;
  height: 100%;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  position: relative;
}

.letter-header {
  height: 10%;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  /* margin-bottom: 20px; */
  padding-bottom: 10px;
}

.letter-actions {
  display: flex;
  gap: 8px;
}

.letter-action-button {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border: 1px solid #e5e7eb;
  border-radius: 6px;
  background: white;
  color: #374151;
  cursor: pointer;
  font-size: 14px;
}

.letter-action-button:hover {
  background: #f9fafb;
}

.letter-content {
  max-height: 80%;
  max-width: 100%;
  overflow-y: scroll;
  line-height: 1.4;
  color: #374151;
  font-size: 16px;
  margin-bottom: 20px;
  padding: 16px;
  padding-top: 0px;
}

.letter-editor {
  width: 100%;
  height: 100%;
  min-height: 300px;
  padding: 16px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  line-height: 1.6;
  font-family: inherit;
  resize: none;
  color: #374151;
  background: white;
}

.letter-editor:focus {
  outline: none;
}

.markdown-content {
  font-size: 14px;
  line-height: 1.4;
  color: #374151;
}

.markdown-content h1,
.markdown-content h2,
.markdown-content h3,
.markdown-content h4,
.markdown-content h5,
.markdown-content h6 {
  margin-top: 1.5em;
  margin-bottom: 0.5em;
  font-weight: 500;
  color: #111827;
}

.markdown-content p {
  margin: 1em 0;
}

.markdown-content ul,
.markdown-content ol {
  margin: 1em 0;
  padding-left: 1.5em;
}

.markdown-content li {
  margin: 0.5em 0;
}

@media (max-width: 580px) {
  .letter-container {
    padding: 10px;
    overflow: auto;
  }
  .letteraction-button {
    gap: 2px;
    padding: 8px;
    font-size: 12px;
  }
  .markdown-content {
    font-size: 14px;
    line-height: 1.4;
  }
  .markdown-content h1,
  .markdown-content h2,
  .markdown-content h3,
  .markdown-content h4,
  .markdown-content h5,
  .markdown-content h6 {
    margin-top: 1em;
  }
  .markdown-content ul,
  .markdown-content ol {
    padding-left: 1.3em;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/selectedSessionComponent/LetterView.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,mBAAmB;EACnB,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,aAAa;EACb,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;;;;EAME,iBAAiB;EACjB,oBAAoB;EACpB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE;IACE,aAAa;IACb,cAAc;EAChB;EACA;IACE,QAAQ;IACR,YAAY;IACZ,eAAe;EACjB;EACA;IACE,eAAe;IACf,gBAAgB;EAClB;EACA;;;;;;IAME,eAAe;EACjB;EACA;;IAEE,mBAAmB;EACrB;AACF","sourcesContent":[".letter-container {\n  padding: 20px;\n  background: white;\n  height: 100%;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  position: relative;\n}\n\n.letter-header {\n  height: 10%;\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  /* margin-bottom: 20px; */\n  padding-bottom: 10px;\n}\n\n.letter-actions {\n  display: flex;\n  gap: 8px;\n}\n\n.letter-action-button {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  padding: 6px 12px;\n  border: 1px solid #e5e7eb;\n  border-radius: 6px;\n  background: white;\n  color: #374151;\n  cursor: pointer;\n  font-size: 14px;\n}\n\n.letter-action-button:hover {\n  background: #f9fafb;\n}\n\n.letter-content {\n  max-height: 80%;\n  max-width: 100%;\n  overflow-y: scroll;\n  line-height: 1.4;\n  color: #374151;\n  font-size: 16px;\n  margin-bottom: 20px;\n  padding: 16px;\n  padding-top: 0px;\n}\n\n.letter-editor {\n  width: 100%;\n  height: 100%;\n  min-height: 300px;\n  padding: 16px;\n  border: 1px solid #e5e7eb;\n  font-size: 14px;\n  line-height: 1.6;\n  font-family: inherit;\n  resize: none;\n  color: #374151;\n  background: white;\n}\n\n.letter-editor:focus {\n  outline: none;\n}\n\n.markdown-content {\n  font-size: 14px;\n  line-height: 1.4;\n  color: #374151;\n}\n\n.markdown-content h1,\n.markdown-content h2,\n.markdown-content h3,\n.markdown-content h4,\n.markdown-content h5,\n.markdown-content h6 {\n  margin-top: 1.5em;\n  margin-bottom: 0.5em;\n  font-weight: 500;\n  color: #111827;\n}\n\n.markdown-content p {\n  margin: 1em 0;\n}\n\n.markdown-content ul,\n.markdown-content ol {\n  margin: 1em 0;\n  padding-left: 1.5em;\n}\n\n.markdown-content li {\n  margin: 0.5em 0;\n}\n\n@media (max-width: 580px) {\n  .letter-container {\n    padding: 10px;\n    overflow: auto;\n  }\n  .letteraction-button {\n    gap: 2px;\n    padding: 8px;\n    font-size: 12px;\n  }\n  .markdown-content {\n    font-size: 14px;\n    line-height: 1.4;\n  }\n  .markdown-content h1,\n  .markdown-content h2,\n  .markdown-content h3,\n  .markdown-content h4,\n  .markdown-content h5,\n  .markdown-content h6 {\n    margin-top: 1em;\n  }\n  .markdown-content ul,\n  .markdown-content ol {\n    padding-left: 1.3em;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
